import { render } from "./Notes8.vue?vue&type=template&id=6078f8d0&scoped=true"
import script from "./Notes8.vue?vue&type=script&lang=js"
export * from "./Notes8.vue?vue&type=script&lang=js"

import "./Notes8.vue?vue&type=style&index=0&id=6078f8d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6078f8d0"]])

export default __exports__